import { IoIosClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { modalFunc } from "../redux/modalSlice";

const Modal = ({ title, content }) => {
  const dispatch = useDispatch();

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-6">
      <div
        className="absolute inset-0 bg-[#050404]/80 backdrop-blur-[2px]"
        onClick={() => dispatch(modalFunc())}
      />
      <div className="relative w-full max-w-lg bg-[#2e1c2b] border border-[#893168]/20 rounded-xl p-8 shadow-[0_32px_64px_-16px_rgba(0,0,0,0.8)]">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl font-black text-white tracking-tight">
            {title}
          </h2>
          <button
            onClick={() => dispatch(modalFunc())}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-white/5 text-gray-500 hover:text-white transition-colors"
          >
            <IoIosClose size={36} />
          </button>
        </div>
        <div className="space-y-1">{content}</div>
      </div>
    </div>
  );
};

export default Modal;
